import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Long-Term Objectives';
const pageSubTitle = 'Long-Term Objectives';
const videoKey = 'YWGdfCD8A4g';

const LongTermObjectives = () => {

    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={
                <>
                    <p>
                        Long-Term Objectives reflect how important it is to make lasting improvements after
                        treatment. These include:
                        <br/>
                        <ul style={{ marginLeft: 16 }}>
                            <li>
                                Ease Pain: Relieving ongoing discomfort.
                            </li>
                            <li>
                                Regain Independence: Managing daily tasks without help
                            </li>
                            <li>
                                Reclaim Activities: Returning to hobbies, work, or movement you enjoy.
                            </li>
                            <li>
                                Achieve Lasting Relief: Benefits that continue over time.
                            </li>
                        </ul>
                    </p>
                    <p>
                        Not every goal matters equally to everyone—and treatments differ in how well they
                        support each one. For example, Total Knee Replacement often provides long-lasting
                        relief and helps with everyday movement. A Cortisone Injection, on the other hand,
                        may ease pain quickly but might not last as long. By focusing on what matters most
                        to you, it's easier to choose a treatment that supports your long-term goals.
                    </p>
                </>
            }
            videoKey={videoKey}
            pageType="criteria"
        />
    );

};

export default LongTermObjectives;